import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BbitWebShopAlgoliaService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteMetaDataService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BehaviorSubject } from 'rxjs';
import { CategoryService } from '../../category/category.service';
import { ItemListItemComponent } from '../item-list/item-list-item/item-list-item.component';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrl: './promotions.component.scss',
  imports: [NgIcon, ItemListItemComponent, AsyncPipe, I18nPipe],
})
export class PromotionsComponent {
  private _meta = inject(BbitWebsiteMetaDataService);
  category = inject(CategoryService);
  private _algolia = inject(BbitWebShopAlgoliaService);

  public hits = new BehaviorSubject<any[]>([]);

  async ngOnInit() {
    this._meta.update({
      title: { key: 'promotion' },
      description: '',
      // keywords: [],
    });
    await this._algolia.clear();
    const algoliaResult = await this._algolia.search({
      query: '',
      filters: '_meta.price.hasPromotion:true',
      hitsPerPage: 128,
    });
    this.hits.next(algoliaResult.hits || []);
  }
}
